import React from 'react'
import { Modal } from "antd"
import style from "./model.module.scss"
import backimg from "assets/img/png/icon_arrow_back@2x.png"

interface Props {
    show?: boolean;
    text?: string;
    onClose?: any;
    onConfirm?: any;
    onCancel?: any;
    title?: any;
    noCancel?: boolean;
    account?: any;

}

const newModal: React.FC<Props> = ({ show = true, text = '用户名或密码错误', onClose, onConfirm, onCancel, title = '提示', noCancel = false, account }) => {
  const handleCancel = () => {
    onCancel()
    // show=false
  }
  const handleOk = () => {
    onConfirm()
  }
  const viewAccount = () => {
    account && account()
  }
  return (
    <Modal width={550} style={{ marginTop: '2rem', height: "3.12rem" }} title={null} footer={null} visible={show} onCancel={handleCancel}>
      <div className={style.backModal}>
        <div className={style.title}>{title}</div>
        <div className={style.line}></div>
        <div className={style.text}>{text}</div>
        <div className={style.btn} onClick={() => handleOk()}>返回首页</div>
        <div className={style.account} onClick={() => viewAccount()}> <img src={backimg} alt="" />  查看账户</div>
      </div>
    </Modal>
  )
}

export default newModal
